import { render } from "./AvatarModal.vue?vue&type=template&id=0ba68227&scoped=true"
import script from "./AvatarModal.vue?vue&type=script&lang=js"
export * from "./AvatarModal.vue?vue&type=script&lang=js"

import "./AvatarModal.vue?vue&type=style&index=0&id=0ba68227&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba68227"]])

export default __exports__